import { render } from "./Snackbar.vue?vue&type=template&id=48ba5f9e"
import script from "./Snackbar.vue?vue&type=script&lang=js"
export * from "./Snackbar.vue?vue&type=script&lang=js"

import "./Snackbar.vue?vue&type=style&index=0&id=48ba5f9e&lang=css"

import exportComponent from "D:\\TeamCity\\BuildAgent2\\work\\1bfd74eb4d5fb108\\FamilyPortalApp\\familyportal-app\\src\\familyportal-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__